export default "__VITE_ASSET__DiFs0o3z__"